import { useEffect, useState } from "react";
import {
  isFeatureFlagEnabled,
  isPostHogConfigured,
  onFeatureFlags,
} from "../analytics/posthog";

export const usePostHogFeatureFlag = (
  flagKey: string,
  defaultValue = false,
) => {
  const [isEnabled, setIsEnabled] = useState(defaultValue);
  const [loading, setLoading] = useState(isPostHogConfigured());

  useEffect(() => {
    if (!isPostHogConfigured()) {
      setIsEnabled(defaultValue);
      setLoading(false);
      return;
    }

    const syncFlag = () => {
      setIsEnabled(isFeatureFlagEnabled(flagKey, defaultValue));
      setLoading(false);
    };

    syncFlag();
    return onFeatureFlags(syncFlag);
  }, [defaultValue, flagKey]);

  return {
    isEnabled,
    loading,
    isPostHogConfigured: isPostHogConfigured(),
  };
};
